import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  getSmartyStreetCandidates,
  getSmartySuggestions,
  getSmartyUnitsForSelected,
} from './mockData'

//
// Mock for Smarty's US Autocomplete Pro lookup, used by the Address Line 1
// field (services/smarty/usAutocompletePro.ts).
//
// This handler is not optional. The worker starts with
// `onUnhandledRequest: 'bypass'` (api/msw/browser.ts), so WITHOUT a handler
// every keystroke in mock mode would quietly reach the real Smarty API and burn
// paid lookups, with nothing in the console to say so.
//
// Note the absolute URL in the path below: makeURL() in ../index.ts passes the
// path straight through to msw's http.get, which accepts a cross-origin URL.
// Unlike every other handler here this one is NOT wrapped in
// requireAuthenticatedUser — it stands in for a third party that knows nothing
// about our session.
//

function getSmartyLookup(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const search = req.url.searchParams.get('search') ?? ''
  const selected = req.url.searchParams.get('selected') ?? ''

  // `selected` means "expand this multi-unit building into its units".
  const suggestions = selected
    ? getSmartyUnitsForSelected(selected)
    : getSmartySuggestions(search)

  console.log(
    `Returning ${suggestions.length} mock Smarty suggestion(s) for` +
      ` ${selected ? `selected="${selected}"` : `search="${search}"`}.`
  )
  return res(ctx.status(200), ctx.json({ suggestions }))
}

// Mock for Smarty's US Street verification (services/smarty/usStreet.ts),
// reached from the address fields' blur handler. Same reasoning as the lookup
// above: without it, mock-mode blur burns paid verifications silently.
//
// Note the response shape differs from the lookup's — US Street returns a BARE
// ARRAY, not a `{ suggestions }` envelope.
function getSmartyStreetVerification(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const street = req.url.searchParams.get('street') ?? ''
  const secondary = req.url.searchParams.get('secondary') ?? ''

  const candidates = getSmartyStreetCandidates({ street, secondary })

  console.log(
    `Returning ${candidates.length} mock Smarty street candidate(s) for` +
      ` street="${street}"${secondary ? ` secondary="${secondary}"` : ''}.`
  )
  return res(ctx.status(200), ctx.json(candidates))
}

export const handlers = [
  {
    method: 'get',
    path: 'https://us-autocomplete-pro.api.smarty.com/lookup',
    handler: getSmartyLookup,
  },
  {
    method: 'get',
    path: 'https://us-street.api.smarty.com/street-address',
    handler: getSmartyStreetVerification,
  },
]
